<template>
  <template v-if="theme === 'sbg'">
    <SBGSignIn></SBGSignIn>
  </template>
  <template v-else>
    <SASAgriSignIn></SASAgriSignIn>
  </template>
</template>

<script setup>
import SBGSignIn from './sign_in/partners/sbg/SignIn.vue'
import SASAgriSignIn from './sign_in/partners/sasagri/SignIn.vue'
import AppConfig from '~/config/appConfig.js'

const theme = AppConfig.theme
</script>
